import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { AnalyticsClickDirective, ClickAreaDirective } from "@directives";
import { TranslatePipe } from "@pipes";
import { CurrencyService } from "@services";

import { AbstractTabComponent } from "../abstract/abstract-tab.component";
import { ButtonComponent } from "../button/button.component";
import { SvgComponent } from "../svg/svg.component";

interface Limit {
  text: string;
  value: string;
}

@Component({
  selector: "mn-limits-tab",
  styleUrls: ["./limits-tab.component.scss"],
  templateUrl: "./limits-tab.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, TranslatePipe, ButtonComponent, AnalyticsClickDirective, ClickAreaDirective],
})
export class LimitsTabComponent extends AbstractTabComponent {
  public prefix = inject(CurrencyService).symbol;

  public ls = computed<Limit[]>(() => {
    const settings = this.acS.cSB$();
    if (!settings) {
      return [];
    }

    return [
      { text: "min-bet", value: settings.min_bet },
      { text: "max-bet", value: settings.max_bet },
      { text: "max-win", value: settings.max_win },
    ];
  });
}
